import styled from "@emotion/styled";
import { AnimatePresence, motion } from "framer-motion";
import React from "react";
import { framerEasings } from "../../../utils/framerUtils";
import {
  AdjustmentsHorizontal20SolidIcon,
  HomeOutlineRoundedIcon,
  MapLightLucideIcon,
  Rows2LightIcon,
} from "../../../utils/icones";
import useMainLayoutPreference from "../hooks/useMainLayoutPreference";
import MapFab from "./MapFab";

export default function MainLayoutFabs(props: {
  offsetBottom: number;
  filterCount: number;
  onClickAdjustments: () => void;
  onClickHome: React.MouseEventHandler<HTMLElement>;
}) {
  const [mainLayout, setMainLayout] = useMainLayoutPreference();

  return (
    <Root
      transition={{ duration: 0.4, ease: framerEasings.custom }}
      animate={{ translateY: -props.offsetBottom }}
    >
      <MapFab onClick={props.onClickAdjustments} badge={props.filterCount}>
        <AdjustmentsHorizontal20SolidIcon />
      </MapFab>

      <AnimatePresence>
        {mainLayout === "Map" && (
          <motion.div
            key="home"
            initial={{ scale: 0, height: 0 }}
            animate={{ scale: 1, height: 48 }}
            exit={{ scale: 0, height: 0, marginTop: -8 }}
          >
            <MapFab onClick={props.onClickHome}>
              <HomeOutlineRoundedIcon />
            </MapFab>
          </motion.div>
        )}
      </AnimatePresence>

      {mainLayout === "Map" && (
        <motion.div key="cards-layout" initial={{ rotate: 180 }} animate={{ rotate: 0 }}>
          <MapFab onClick={() => setMainLayout("Cards")}>
            <Rows2LightIcon width={22} />
          </MapFab>
        </motion.div>
      )}

      {mainLayout === "Cards" && (
        <motion.div key="map-layout" initial={{ rotate: 180 }} animate={{ rotate: 0 }}>
          <MapFab onClick={() => setMainLayout("Map")}>
            <MapLightLucideIcon width={22} />
          </MapFab>
        </motion.div>
      )}
    </Root>
  );
}

const Root = styled(motion.div)`
  display: flex;
  flex-direction: column;
  margin-inline-start: auto;
  gap: 8px;
  width: fit-content;

  @media (max-height: 700px) {
    flex-direction: row;
  }
`;
